import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type GlobalSettingsChangePayload = {
  modified_data?: number;
  qb_data_status?: number;
  qb_active?: number;
  qb_data_entry_type?: number;
  qb_increment_units?: number;
  qb_increment_carbs?: number;
  button_volume?: number;
  qb_volume?: number;
  bolus_volume?: number;
  reminder_volume?: number;
  alert_volume?: number;
};

export type GlobalSettingsChangeEvent = {
  modifiedData?: number;
  qbDataStatus?: number;
  qbActive?: number;
  qbDataEntryType?: number;
  qbIncrementUnits?: number;
  qbIncrementCarbs?: number;
  buttonVolume?: number;
  qbVolume?: number;
  bolusVolume?: number;
  reminderVolume?: number;
  alertVolume?: number;
};

const globalSettingsChangeSchema = z.object({
  modified_data: cz.permissive(z.number()),
  qb_data_status: cz.permissive(z.number()),
  qb_active: cz.permissive(z.number()),
  qb_data_entry_type: cz.permissive(z.number()),
  qb_increment_units: cz.permissive(z.number()),
  qb_increment_carbs: cz.permissive(z.number()),
  button_volume: cz.permissive(z.number()),
  qb_volume: cz.permissive(z.number()),
  bolus_volume: cz.permissive(z.number()),
  reminder_volume: cz.permissive(z.number()),
  alert_volume: cz.permissive(z.number()),
});

export const LID_PARAM_GLOBAL_SETTINGS = {
  value: 0x4a,
  name: "Global Settings Change Event",
  format: "bbbbhhbbbbbb..",
  fields: [
    "modified_data",
    "qb_data_status",
    "qb_active",
    "qb_data_entry_type",
    "qb_increment_units",
    "qb_increment_carbs",
    "button_volume",
    "qb_volume",
    "bolus_volume",
    "reminder_volume",
    "alert_volume",
  ],
  postprocess: rec => ({
    modifiedData: rec.modified_data,
    qbDataStatus: rec.qb_data_status,
    qbActive: rec.qb_active,
    qbDataEntryType: rec.qb_data_entry_type,
    qbIncrementUnits: rec.qb_increment_units ? rec.qb_increment_units * 0.001 : undefined,
    qbIncrementCarbs: rec.qb_increment_carbs ? rec.qb_increment_carbs * 0.001 : undefined,
    buttonVolume: rec.button_volume,
    qbVolume: rec.qb_volume,
    bolusVolume: rec.bolus_volume,
    reminderVolume: rec.reminder_volume,
    alertVolume: rec.alert_volume,
  }),
  schema: globalSettingsChangeSchema,
} as const satisfies TandemEventDefinition<GlobalSettingsChangePayload, GlobalSettingsChangeEvent>;
